import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, Button } from "@mui/material";
import { useState } from "react";
import MainInfo from "../components/MainInfo";
import Advantages from "../components/Advantages";
import Prices from "../components/Prices";
import AskedQuestions from "../components/AskedQuestions";

const HomePage = () => {
  const [isContactUsFormOpen, setIsContactUsFormOpen] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData);

    fetch('https://api.hajjtravel.kz/api/public/requests', {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(response => response.json())
      .then(data => {
        console.log(data);
        alert('Заявка отправлена, мы свяжемся с вами в ближайшее время');
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Ошибка при отправке заявки, попробуйте позже');
      }).finally(() => {
        setIsContactUsFormOpen(false);
      });

  };

  const showContactUsForm = () => {
    setIsContactUsFormOpen(true);
  };

  const partners = [
    {
      name: "SafarLike Travel",
      image: "/images/partners/safarlike.jpeg",
      link: "https://instagram.com/safarlike.kz",
    },
  ];
  return (
    <>      
      <MainInfo showContactUsForm={showContactUsForm} />
      <Advantages />
      <Prices showContactUsForm={showContactUsForm} />
      <section>
        <div className="mx-auto py-8 px-4">
          <h2 className="text-2xl font-bold text-center mb-8">🌟 Почему стоит выбрать HajjTravel?</h2>
          <div className="flex flex-col gap-4">
            <h3>Наши тарифы основаны на реальных преимуществах, которые ваша турфирма получит от использования нашей платформы:</h3>
            <ul>
              <li>✅ Снижение затрат – автоматизация процессов позволяет вашему менеджеру выполнять задачи быстрее, без необходимости в нескольких сотрудниках. Один менеджер может справляться с тем, что раньше требовало целой команды.</li>
              <li>✅ Больше клиентов – автоматизация заказов, уведомлений повышает качество обслуживания и помогает привлекать новых клиентов.</li>
              <li>✅ Увеличение прибыли – аналитика, маркетинг, система лояльности помогут вам увеличить повторные продажи и удержание клиентов.</li>
              <li>✅ Конкурентное преимущество – турфирмы, использующие HajjTravel, получают доступ к инновационным решениям, которые делают их сервис более технологичным и привлекательным для клиентов.</li>
              <li>✅ Мы помогаем вам организовать паломничество, чтобы каждый клиент чувствовал заботу и комфорт в процессе.</li>
            </ul>
          </div>
        </div>
      </section>
      <AskedQuestions />
      <section id="partners" className="mt-20">
        <div className="mx-auto py-8 px-4">
          <h2 className="text-2xl font-bold text-center mb-8">Наши партнеры</h2>
          <div className="flex flex-wrap justify-center gap-4">
            {partners.map((partner) => (
              <div className="w-36 h-36 object-contain">
                <a href={partner.link} target="_blank" rel="noopener noreferrer">
                  <img src={partner.image} alt={partner.name} />
                  <span>{partner.name}</span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section id="about-us" className="bg-gray-50 mt-20">
        <div className="mx-auto py-8 px-4">
          <h2 className="text-2xl font-bold text-center">О нас</h2>
          <div className="flex flex-col lg:flex-row">
            <div>
              <p className="text-gray-500 mb-4">
                Наша миссия — Упростить процесс бронирования туров, сделать паломничество комфортным и организованным, использовать современные технологии для помощи путешественникам.
              </p>
              <p className="text-gray-500">
                <div className="font-bold">Чем мы занимаемся:</div>
                <ul className="list-disc pl-5">
                  <li>Выбор туристических пакетов: Представлены различные пакеты &mdash; от стандартных до VIP &mdash; с подробным описанием услуг, маршрутов, условий проживания и цен. Вы можете выбрать подходящий вариант и забронировать его непосредственно в приложении.</li>
                  <li>GPS-навигация: Предоставляются точные карты и маршруты для посещения священных мест, а также информация о местоположении гидов и других паломников.</li>
                  <li>Пошаговые инструкции: Детальные указания по выполнению всех обрядов Умры и Хаджа.</li>
                  <li>Кнопка SOS: Быстрая связь для получения помощи и совета.</li>
                  <li>Информация о поездке: Расписание трансферов, информация об отелях, экскурсиях и бронированиях.</li>
                  <li>Напоминания: Уведомления о времени и последовательности обрядов.</li>
                  <li>AI Искусственный интеллект с помощью которого вы можете получить ответы на вопросы пользователей</li>
                </ul>
              </p>
              <p className="text-gray-500 mb-4">
                Мы верим, что технологии могут сделать каждый этап путешествия простым, безопасным и вдохновляющим.
              </p>
              <p className="text-gray-500 mb-4">
                <div className="font-bold">Почему это важно?</div>
                Вместе с вами мы хотим создать сообщество, которое делает путешествия удобными, доступными и запоминающимися.
              </p>
              <p className="text-gray-500 mb-4">
                <div className="font-bold">Мы в соцсетях:</div>
                <ul className="list-disc pl-5">
                  <li>Instagram: <a href="https://www.instagram.com/hajjtravel_app" target="_blank" rel="noopener noreferrer">hajjtravel_app</a></li>
                  <li>LinkedIn: <a href="https://www.linkedin.com/company/hajjtravel" target="_blank" rel="noopener noreferrer">hajjtravel</a></li>
                </ul>
              </p>
            </div>
            <div className="w-full lg:w-1/2">
              <img className="w-full h-full object-cover rounded-lg" src="/images/about-us.jpeg" alt="About Us" />
            </div>
          </div>
        </div>
      </section>
      <section id="contact-us">
        <div className="mx-auto py-8 px-4">
          <h2 className="text-2xl font-bold text-center">Свяжитесь с нами</h2>
          <div className="flex flex-col gap-4">
            <div>
              <strong>Телефон</strong>
              <p>
                <a className="text-blue-500" href="tel:+77054083130">+7 705 408 31 30</a>
              </p>
            </div>
            <div>
              <strong>WhatsApp</strong>
              <p>
                <a className="text-blue-500" href="https://wa.me/77054083130">+7 705 408 31 30</a>
              </p>
            </div>
            <div>
              <strong>Email</strong>
              <p>
                <a className="text-blue-500" href="mailto:info@hajjtravel.kz">info@hajjtravel.kz</a>
              </p>
            </div>
            <div>
              <strong>Адрес</strong>
              <p>
                Мы находимся по адресу: г. Алматы, ул. Утепова, 10
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Dialog open={isContactUsFormOpen} onClose={() => setIsContactUsFormOpen(false)}>
        <DialogTitle>Обратная связь</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <form onSubmit={handleSubmit}>
              <TextField
                label="Имя"
                name="name"
                required
                fullWidth
                margin="normal"
              />
              <TextField
                label="Телефон"
                name="phone"
                required
                fullWidth
                margin="normal"
              />
              <TextField
                label="Сообщение"
                name="message"
                required
                fullWidth
                multiline
                rows={4}
              />
              <Button type="submit" variant="contained" color="primary" style={{ marginTop: '16px' }}>
                Оставить заявку
              </Button>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HomePage;
